/* ═══════════════════════════════════════════════════════════════
   BUP Article Post — Blog içeriği etkileşimleri
   ---------------------------------------------------------------
   .bup-art sarmalayıcısı içindeki bileşenleri çalıştırır:
   okuma çubuğu, içindekiler, mobil menü, sekmeler, SSS, grafikler.

   Tüm etkileşimler event delegation ile bağlanır — HTML'de inline
   onclick YAZILMAZ. Yeni makale eklerken bu dosyaya dokunmaya gerek
   yoktur; doğru class/data-* kullanmak yeterlidir.

   Chart.js yalnızca sayfada [data-chart] varsa ve grafik ekrana
   yaklaştığında indirilir (~200 KB boşuna yüklenmez).
   ═══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var root = document.querySelector('.bup-art');
  if (!root) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ─── Okuma ilerleme çubuğu ───────────────────── */
  var fill = root.querySelector('.progress-fill');
  if (fill) {
    var ticking = false;
    var updateProgress = function () {
      var doc = document.documentElement;
      var sc = doc.scrollTop || document.body.scrollTop;
      var ht = doc.scrollHeight - doc.clientHeight;
      fill.style.width = (ht > 0 ? (sc / ht) * 100 : 0) + '%';
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(updateProgress); }
    }, { passive: true });
    updateProgress();
  }

  /* ─── Tıklama işlemleri (delegation) ──────────── */
  root.addEventListener('click', function (e) {
    var t = e.target;

    // Mobil içindekiler aç/kapa
    var mnavBtn = t.closest('.mnav-btn');
    if (mnavBtn) {
      var mnav = mnavBtn.closest('.mnav');
      if (mnav) mnav.classList.toggle('open');
      return;
    }

    // İç bağlantı: yumuşak kaydırma + mobil menüyü kapat
    var anchor = t.closest('a[href^="#"]');
    if (anchor) {
      var id = anchor.getAttribute('href').slice(1);
      var target = id && document.getElementById(id);
      if (target) {
        e.preventDefault();
        var openNav = root.querySelector('.mnav.open');
        if (openNav) openNav.classList.remove('open');
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY - 24,
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      }
      return;
    }

    // Sekme değiştirici (SERP vb.)
    var tab = t.closest('.serp-tab');
    if (tab) {
      var panelId = tab.getAttribute('data-target');
      var tabs = tab.closest('.serp-tabs');
      if (panelId && tabs) {
        tabs.querySelectorAll('.serp-tab').forEach(function (x) { x.classList.remove('active'); });
        tabs.querySelectorAll('.serp-panel').forEach(function (p) { p.classList.remove('active'); });
        tab.classList.add('active');
        var panel = document.getElementById(panelId);
        if (panel) panel.classList.add('active');
      }
      return;
    }

    // SSS aç/kapa
    var faqQ = t.closest('.serp-faq-q');
    if (faqQ) {
      var item = faqQ.closest('.serp-faq-item');
      if (item) item.classList.toggle('open');
    }
  });

  /* ─── İçindekiler: aktif bölüm ────────────────── */
  var sections = root.querySelectorAll('[id]');
  var railItems = root.querySelectorAll('.rail-item');
  if (railItems.length && 'IntersectionObserver' in window) {
    var tracked = [];
    railItems.forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;
      var sec = document.getElementById(href.slice(1));
      if (sec) tracked.push(sec);
    });

    if (tracked.length) {
      var tocObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          railItems.forEach(function (l) { l.classList.remove('active'); });
          var active = root.querySelector('.rail-item[href="#' + entry.target.id + '"]');
          if (active) active.classList.add('active');
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      tracked.forEach(function (s) { tocObserver.observe(s); });
    }
  }

  /* ─── Grafikler: Chart.js tembel yükleme ──────── */
  var canvases = root.querySelectorAll('canvas[data-chart]');
  if (!canvases.length) return;

  var CHART_SRC = 'https://cdn.jsdelivr.net/npm/chart.js@4.4.1/dist/chart.umd.min.js';
  var chartLoading = null;

  function loadChartJs() {
    if (window.Chart) return Promise.resolve(window.Chart);
    if (chartLoading) return chartLoading;
    chartLoading = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = CHART_SRC;
      s.async = true;
      s.onload = function () { resolve(window.Chart); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return chartLoading;
  }

  function nums(str) {
    return (str || '').split(',').map(function (v) { return parseFloat(v.trim()); }).filter(function (v) { return !isNaN(v); });
  }
  function strs(str) {
    return (str || '').split(',').map(function (v) { return v.trim(); }).filter(Boolean);
  }

  function buildChart(canvas) {
    if (canvas.dataset.built) return;
    canvas.dataset.built = '1';

    var d = canvas.dataset;
    var type = d.chart === 'bar' ? 'bar' : 'line';
    var labels = strs(d.labels);
    var values = nums(d.values);
    if (!labels.length || !values.length) return;

    var suffix = d.suffix || '';
    var horizontal = d.horizontal === 'true';
    var colors = strs(d.colors);
    var ink = '#5C6B66';
    var grid = '#E2E5DC';

    var dataset = {
      label: d.seriesLabel || '',
      data: values
    };

    if (type === 'line') {
      dataset.borderColor = d.color || '#2DA88A';
      dataset.backgroundColor = d.fillColor || 'rgba(67,203,169,0.12)';
      dataset.fill = d.fill !== 'false';
      dataset.tension = 0.4;
      dataset.borderWidth = 3;
      dataset.pointBackgroundColor = '#43CBA9';
      dataset.pointBorderColor = '#10221F';
      dataset.pointBorderWidth = 2;
      dataset.pointRadius = 5;
      dataset.pointHoverRadius = 7;
    } else {
      dataset.backgroundColor = colors.length ? colors : '#43CBA9';
      dataset.borderRadius = 6;
      dataset.borderSkipped = false;
    }

    var tickFmt = function (v) { return v + suffix; };
    var valueAxis = {
      beginAtZero: d.yMin === undefined,
      grid: { color: grid },
      ticks: { callback: tickFmt, color: ink, font: { weight: '600', size: 11 } }
    };
    if (d.yMin !== undefined) { valueAxis.min = parseFloat(d.yMin); valueAxis.beginAtZero = false; }

    var labelAxis = {
      grid: { display: false },
      ticks: { color: ink, font: { weight: '600', size: 12 } }
    };

    new window.Chart(canvas, {
      type: type,
      data: { labels: labels, datasets: [dataset] },
      options: {
        indexAxis: horizontal ? 'y' : 'x',
        responsive: true,
        maintainAspectRatio: false,
        animation: !reduceMotion,
        plugins: { legend: { display: d.legend === 'true' } },
        scales: horizontal
          ? { x: valueAxis, y: labelAxis }
          : { y: valueAxis, x: labelAxis }
      }
    });
  }

  function activate(canvas) {
    loadChartJs().then(function () { buildChart(canvas); }).catch(function () {});
  }

  if ('IntersectionObserver' in window) {
    var chartObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        chartObserver.unobserve(entry.target);
        activate(entry.target);
      });
    }, { rootMargin: '300px 0px' });
    canvases.forEach(function (c) { chartObserver.observe(c); });
  } else {
    canvases.forEach(activate);
  }
})();
